<template>
  <v-card :loading="userLoading">
    <v-card-title>
      Users
      <template v-if="!userLoading">
        <BeehiveIcon :link="articleLinks.users" />

        <v-spacer></v-spacer>

        <template v-if="disableIfNotStatus([],['live']) || disableIfNotTariff">
          <v-tooltip top color="primary">

            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-btn color="secondary" x-small disabled><v-icon small>add</v-icon> Add User/s</v-btn>
              </div>
            </template>

            <template>
              <span v-if="disableIfNotTariff">You must select a tariff before adding users</span>
              <span v-else>Cannot add user due to <br>product status being <b>{{product.status}}</b></span>
            </template>

          </v-tooltip>
        </template>

        <template v-else>
          <v-btn color="secondary" x-small @click.prevent="$emit('open-add-user')"><v-icon small>add</v-icon> Add User/s</v-btn>
        </template>

      </template>
    </v-card-title>
    <template v-if="!userLoading">

      <v-card-text v-if="product.children.length!==0">
        <v-row>
          <v-col cols="12" md="4" v-for="(user,i) in productChildren" :key="i">
            <v-card>

              <v-card-title>
                {{user.id}}
                <v-spacer></v-spacer>

                <v-btn color="secondary" x-small @click.prevent="$emit('open-user-status-history', user)"><v-icon small>history</v-icon></v-btn>

                <template v-if="user.sold_date || disableIfStatus(user.status,['upgrade','legacy upgrade','warm','index','inbound','for approval','verification','provisioning failed','live','provisioned'])">
                  <v-tooltip top color="primary">

                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-btn color="secondary" x-small disabled><v-icon small>edit</v-icon></v-btn>
                      </div>
                    </template>

                    <span v-if="user.sold_date">Cannot edit user as user has a sold date</span>
                    <span v-else>Cannot edit user due to this<br> users status being <b>{{user.status}}</b></span>

                  </v-tooltip>
                </template>

                <template v-else>
                  <v-btn color="secondary" x-small @click.prevent="$emit('open-edit-user',user)"><v-icon small>edit</v-icon></v-btn>
                </template>

                <template v-if="user.sold_date===null||enableIfStatus(user.status,['for approval'])">
                  <v-btn class="ml-3" color="error" x-small @click="deleteUser(user);"><v-icon small>delete</v-icon></v-btn>
                </template>

              </v-card-title>

              <v-card-text>
                <v-row>

                  <v-col cols="12" md="6">

                    <div class="mb-1">
                      <span class="text-caption mr-1">Extension</span>
                      <InfoTooltip top>
                        Internal number other users can dial to call this user
                      </InfoTooltip>
                    </div>
                    <p><b>{{user.product_details.extension | notEmpty}}</b></p>

                    <p class="mb-1 text-caption">Sold date</p>
                    <p><b>{{user.sold_date | notEmpty}}</b></p>

                    <template v-if="!openCards[user.id]">
                      <p class="mb-1 text-caption">Status <v-icon small @click="openStatusChange(user)">edit</v-icon></p>
                      <p><b>{{user.status | notEmpty}}</b></p>
                    </template>

                    <template v-else>
                      <v-row>
                        <v-col cols="8"><v-select v-model="statusChange" :items="getProductStatuses" label="Select Status" dense outlined hide-details :disabled="statusesLoading||statusUpdateLoading" :loading="statusesLoading||statusUpdateLoading"></v-select></v-col>
                        <v-col cols="2" class="mt-2"><v-icon :disabled="statusUpdateLoading" :loading="statusUpdateLoading" color="secondary" @click="updateStatus(user)">check</v-icon></v-col>
                        <v-col cols="2" class="mt-2"><v-icon :disabled="statusUpdateLoading" :loading="statusUpdateLoading" color="error" @click="$delete(openCards, user.id)">close</v-icon></v-col>
                      </v-row>
                    </template>

                  </v-col>

                  <v-col cols="12" md="6">

                    <template v-if="!ddiNumberChange[user.id]">
                      <div class="mb-1">
                        <span class="text-caption mr-1">DDI</span>
                        <InfoTooltip top>
                          Phone number people can call to connect directly to this user
                        </InfoTooltip>
                        <v-icon small @click="openDDI(user)">edit</v-icon>
                      </div>
                      <p><b>{{(user.product_details.number_id!==null)?user.product_details.number.number:'-'}}</b></p>
                    </template>

                    <template v-else>
                      <div class="d-flex justify-start align-center mb-4">
                        <div><v-select v-model="ddiNumber" :items="getDdiNumbers" :disabled="isDdiLoading" :loading="isDdiLoading" label="Select DDI number" hide-details dense outlined /></div>
                        <div><v-icon color="secondary" @click="updateDdiNumber(user, ddiNumber)" :disabled="isDdiLoading">check</v-icon></div>
                        <div><v-icon color="error" @click="$delete(ddiNumberChange, user.id)" :disabled="isDdiLoading">close</v-icon></div>
                      </div>
                    </template>
                    
                    <p class="mb-1 text-caption">Contract start date</p>
                    <p><b>{{user.contract_start_date | notEmpty}}</b></p>

                    <p class="mb-1 text-caption">Total Price</p>
                    <p><b>£{{user.monthly_total|formatPrice}}</b></p>
                  </v-col>
                </v-row>

                <v-row v-if="user.addons.length!==0">
                  <v-col>
                    <v-chip-group column>
                      <template v-for="(add,addi) in showAddons(user.addons)">
                        <v-chip x-small :key="addi">{{showAddonName(add,user.tariff_id)}}</v-chip>
                      </template>
                    </v-chip-group>
                  </v-col>
                </v-row>
              </v-card-text>

            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
  import { mapState,mapActions,mapGetters } from "vuex";
  import BeehiveIcon from '@/components/Globals/BeehiveIcon';
  import { articleLinks } from '@/helpers/links';
  import InfoTooltip from '@/components/Base/InfoTooltip';

  export default {
    components: { BeehiveIcon, InfoTooltip },

    data() {
      return {
        statusChange: '',
        openCards: {},
        articleLinks,
        ddiNumberChange: {},
        isDdiLoading: false,
        ddiNumber: "",
      }
    },

    props: [ 'userLoading','product','productChildren','addons','siteInitial','productAllTariffs','userNumbers' ],

    computed: {

      ...mapState('products',['statusesLoading','statusUpdateLoading']),
      ...mapGetters('products',['getProductStatuses', 'getDeleteProductChildError']),

      getDdiNumbers() {
        return [...this.userNumbers, {text:'No Number',value:null}];
      },

      disableIfNotTariff(){
        let ret = (this.siteInitial.tariff.id === "" || this.siteInitial.tariff.id === null) || (this.siteInitial.cLength === "" || this.siteInitial.cLength === null);
        return ret;
      },

      _productAllTariffs() {
        const productAllTariffs = this.productAllTariffs || [];
        return productAllTariffs.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});
      },

    },

    filters: {

      formatPrice: (val)=>{
        return parseFloat(val).toFixed(2);
      },

      notEmpty: (val)=>{
        return (val === null || val === "" || val === undefined)?'-':val;
      }

    },

    methods: {

      ...mapActions('products',['deleteProductChild','fetchProductStatuses','updateProductStatuses','updateChildProductNumber']),

      openDDI(user) {
        const hasOpen = Object.keys(this.ddiNumberChange).length > 0;
        this.ddiNumber = '';
        if(!hasOpen){
          this.$set(this.ddiNumberChange, user.id, true);
        }else{
          this.ddiNumberChange = {};
          this.ddiNumberChange[user.id] = true;
        }
      },

      async updateDdiNumber(user, number) {
        this.isDdiLoading = true;
        await this.updateChildProductNumber({ id: user.id, number });
        await this.$emit('updateDdi');
        this.$delete(this.ddiNumberChange, user.id);
        this.isDdiLoading = false;
      },

      async openStatusChange(user){
        const hasOpen = Object.keys(this.openCards).length > 0;
        this.statusChange = '';
        if(!hasOpen){
          this.$set(this.openCards, user.id, true);
        }else{
          this.openCards = {};
          this.openCards[user.id] = true;
        }
        await this.fetchProductStatuses(user.id);
      },
      
      async updateStatus(user){
        let data = {
          productId: user.id,
          status: {status: this.statusChange}
        }
        let success = await this.updateProductStatuses(data);
        if(success){
          this.$delete(this.openCards, user.id);
          window.location.reload();
        }
      },

      async deleteUser(user){
        if(confirm(`Are you sure you want to delete this user: ${user.id}`)){
          await this.deleteProductChild(user.id);
          await this.$emit('user-deleted');

          if (!this.getDeleteProductChildError) {
            setTimeout(()=>{
              window.location.reload();
            }, 850);     
          }
        }
      },

      findTariffById(id){
        return (id===null||id===undefined)?{id:'',addons:[],name: '-',price:0}:this._productAllTariffs[id];
      },

      isIncludedAddon(id,addons){
        addons = addons || [];
        let adds = addons.map((add=>{return add.id;}));
        return adds.indexOf(id)!==-1;
      },

      showAddonName(addId,userTariff){
        let tariff = this.findTariffById(userTariff) || {};
        let price = (this.isIncludedAddon(addId,tariff.addons))?' - Included':` - £${this.addons[addId].price}`;
        return this.addons[addId].name+price;
      },

      showAddons(addons){
        let addonGroups = {};
        let returnedAddons = [];
        addons.forEach(add => {
          let addon = this.addons[add.addon_id];
          if(addon!==undefined){
            if(addon.display_group===null){
              returnedAddons.push(add.addon_id);
            }else{
              if(addonGroups[addon.display_group]===undefined){ addonGroups[addon.display_group] = []; }
              addonGroups[addon.display_group].push(this.addons[add.addon_id]);
            }
          }
        });
        Object.keys(addonGroups).forEach(key => {
          let group = addonGroups[key];
          group.sort(function(a,b){return b['group_rank']-a['group_rank']});
          returnedAddons.push(group[0].id);
        });
        return returnedAddons;
      },

      disableIfStatus(status,statuses){
        return statuses.indexOf(status.toLowerCase())===-1;
      },

      enableIfStatus(status,statuses){
        return statuses.indexOf(status.toLowerCase())!==-1;
      },

      disableIfNotStatus(exceptions, allowed){
        let pStatus = this.product.status.toLowerCase();
        if(exceptions!==undefined){
          return exceptions.indexOf(pStatus)!==-1;
        }
        if(!Array.isArray(allowed)) {
          allowed = [];
        }
        let statusCanEdit = ["warm","index","inbound", "for approval","verification","provisioning failed"].concat(allowed);
        return (statusCanEdit.indexOf(pStatus)===-1);
      },
      
    },
  }
</script>

<style lang="scss" scoped></style>
